<!--begin::Form-->
<form class="form w-100" [formGroup]="form" novalidate="novalidate" id="kt_login_signin_form">
  <!--begin::Heading-->
  <div class="text-center mb-11">
    <h1 class="text-dark fw-bolder mb-3">Seja bem vindo</h1>
    <!--begin::Subtitle-->
    <!-- <div class="text-gray-500 fw-semibold fs-6">Your Social Campaigns</div> -->
    <!--end::Subtitle--->
    <div class="text-gray-800 fw-bold fs-4">
      Não tem uma conta?
      <a routerLink="/auth/register" id="kt_login_signup" class="link-primary fw-bolder">Criar Conta</a>
    </div>
  </div>
  <!--end::Heading-->

  <!--begin::Form group-->
  <div class="fv-row mb-8">
    <label class="form-label fs-6 fw-bolder text-dark">Login</label>
    <input class="form-control bg-transparent" type="email" name="email" formControlName="email" autocomplete="off" />
    <app-field-control-error [control]="form.get('email')" label="E-mail"></app-field-control-error>
  </div>
  <!--end::Form group-->

  <!--begin::Form group-->
  <div class="fv-row mb-3">
    <label class="form-label fw-bolder text-dark fs-6">Senha</label>
    <!--begin::Password-->

    <div class="input-group">
      <input [type]="showPass ? 'text' : 'password'" autocomplete="off" class="form-control bg-transparent"
        formControlName="password" />
      <span class="input-group-text">
        <a href="javascript:;" (click)="togglePass()">
          <app-keenicon [name]="showPass ? 'eye' : 'eye-slash'" class="fs-3 text-gray-900"></app-keenicon>
        </a>
      </span>
    </div>

    <app-field-control-error [control]="form.get('password')" label="Senha"></app-field-control-error>
    <!--end::Password-->
  </div>
  <!--end::Form group-->

  <!--begin::Wrapper-->
  <div class="d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8">
    <div></div>

    <!--begin::Link-->
    <a routerLink="/auth/forgot-password" class="">
      Esqueci minha senha?
    </a>
    <!--end::Link-->
  </div>
  <!--end::Wrapper-->

  <!--begin::Action-->
  <div class="d-grid">
    <button type="submit" id="kt_sign_in_submit" class="btn btn-primary" (click)="submit()">
      <ng-container *ngIf="loading$ | async">
        <span class="indicator-progress" [style.display]="'block'">
          Aguarde...
          <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
        </span>
      </ng-container>
      <ng-container *ngIf="(loading$ | async) === false">
        <span class="indicator-label">Login</span>
      </ng-container>
    </button>
  </div>

  <!-- <div class="text-gray-600 text-center fw-semibold fs-6">
    Primeiro acesso? Utilizar os 6 primeiros dígitos do seu CPF ou CNPJ como senha!
  </div> -->

  <!--end::Action-->
</form>
<!--end::Form-->
